export default __webpack_public_path__ + "static/media/list.7b574e58.svg";